import React from "react";

import { Toolbar, ToolbarGroup } from "../Toolbar";
import {
  InputGroup,
  Popover,
  ButtonGroup,
  Button,
  Menu,
  MenuItem
} from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";

function ProductPageHeader({
  searchText,
  onSearchTextChange,
  onAddProductPress,
  onExportPress,
  onImportPress
}) {
  return (
    <Toolbar title="Products">
      <ToolbarGroup>
        <InputGroup
          type="search"
          placeholder="Search..."
          leftIcon={<Icon name="search" color="#8a9ba8" />}
          value={searchText}
          onChange={onSearchTextChange}
        />
      </ToolbarGroup>

      <ToolbarGroup>
        <ButtonGroup>
          <Button
            icon="plus"
            className="narrow bold"
            text="Add Product"
            onClick={onAddProductPress}
          />

          <Popover>
            <Button icon="caret-down" className="narrow" />

            <Menu>
              <MenuItem
                icon="import"
                text="Import CSV"
                onClick={onImportPress}
              />
              <MenuItem
                icon="export"
                className="narrow bold"
                text="Export CSV"
                onClick={onExportPress}
              />
            </Menu>
          </Popover>
        </ButtonGroup>
      </ToolbarGroup>
    </Toolbar>
  );
}

export default ProductPageHeader;
